import * as React from 'react';

import { cn } from '../../utils/cn';
import { QUESTIONNAIRE_COLOUR } from './questionnaire-tokens';

export interface QuestionnaireProgressProps {
    /** Name of the flow, e.g. `Get Matched`. */
    label: string;
    /** 1-based position of the current step. */
    step: number;
    /** Total number of steps in the flow. */
    total: number;
    className?: string;
}

/**
 * The eyebrow above the step heading: `Get Matched · step 3 of 9`.
 *
 * Announced politely rather than assertively — the heading change already moves
 * focus, and an assertive region would interrupt it.
 */
export const QuestionnaireProgress = ({
    label,
    step,
    total,
    className,
}: QuestionnaireProgressProps) => (
    <p
        aria-live="polite"
        className={cn(
            'font-sans text-3.5 leading-[1.1] tracking-[-0.035em]',
            QUESTIONNAIRE_COLOUR.inkMuted,
            className,
        )}
    >
        {label} · step {step} of {total}
    </p>
);
